import {defineStore} from 'pinia';
import {ModuleAsset} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import assetAPI from '@/apis/di/assetAPI';
const assetStore = new BaseDictionaryStore(assetAPI);
export const useAssetStore = defineStore(ModuleAsset, {
  state: () => ({
    ...assetStore.state,
    _config: {
      key: 'asset_id',
      code: 'asset_alias',
      name: 'asset_name',
      table: 'di_asset',
      quickFollow: 'active',
      moduleName: 'Tài sản tang vật',
      defaultSort: 'asset_alias',
    },
    moduleName: 'diAsset',
  }),
  actions: {...assetStore.action},
  getters: {
    ...assetStore.getters,
  },
});
